// Utility function to decode JWT token
const decodeJWT = (token: string) => {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const decodedData = JSON.parse(atob(base64));
    return decodedData;
};


const formatSummaryReportData = (summaryReportData: any) => {
    const formateddata: any = {
        OrganizationDescription: {
            Contact_Surname__c: summaryReportData.Contact_Surname__c,
            Contact_First_Name__c: summaryReportData.Contact_First_Name__c,
            Phone_Cell__c: summaryReportData.Phone_Cell__c,
            Street_Address__c: summaryReportData.Street_Address__c,
            General_Description__c: summaryReportData.General_Description__c,
            Email__c: summaryReportData.Email__c,
            Status__c: summaryReportData.Status__c,
            Website__c: summaryReportData.Website__c,
            Allowable_Size_Limit__c: summaryReportData.Allowable_Size_Limit__c
        },
        ConfirmationOfChanges: {
            Audit_Type__c: summaryReportData.Audit_Type__c,
            Auditor_Name__c: summaryReportData.Auditor_Name__c,
            Description_Of_Changes__c: summaryReportData.Description_Of_Changes__c
        },
        certificateScope: {
            FSC_STD_Reclaimed_Material__c: summaryReportData.FSC_STD_Reclaimed_Material__c,
            FSC_STD_Controlled_Wood_Sourcing__c: summaryReportData.FSC_STD_Controlled_Wood_Sourcing__c,
            FSC_STD_Chain_Of_Custody__c: summaryReportData.FSC_STD_Chain_Of_Custody__c,
            FSC_STD_Project_Certification__c: summaryReportData.FSC_STD_Project_Certification__c,
            FSC_STD_Trademark_Use__c: summaryReportData.FSC_STD_Trademark_Use__c,
            FSC_STD_Multiple_Sites_Group__c: summaryReportData.FSC_STD_Multiple_Sites_Group__c,
            Allowable_Size_Limit__c: summaryReportData.Allowable_Size_Limit__c
        },

        FscProductGroupList: {
            FSC_Product_Group_List__c: summaryReportData.FSC_Product_Group_List__c,
            PGL_FSC_as_seperate_record__c: summaryReportData.PGL_FSC_as_seperate_record__c,
            Product_List_Comparison_SCS_FSC__c: summaryReportData.Product_List_Comparison_SCS_FSC__c
        },
        productCategories: {
            PEFC_SFI_RW_Product_Categories__c: summaryReportData.PEFC_SFI_RW_Product_Categories__c,
            Product_List_Comparison_SCS_PEFC__c: summaryReportData.Product_List_Comparison_SCS_PEFC__c,
        },

        ReclaimedMaterialsInfo: {
            Reclaimed_Materials_Information__c: summaryReportData.Reclaimed_Materials_Information__c,
            Description_of_the_organization_s_verifi__c: summaryReportData.Description_of_the_organization_s_verifi__c,
        },

        MultiSiteGroupInfo: {
            Multi_Site_Group_Information__c: summaryReportData.Multi_Site_Group_Information__c,
            Describe_Management_System__c: summaryReportData.Describe_Management_System__c,
            Describe_Management_of_non_conformities__c: summaryReportData.Describe_Management_of_non_conformities__c,
            Describe_Material_sourcing__c: summaryReportData.Describe_Material_sourcing__c,
            Description_Group_Multisite_Level__c: summaryReportData.Description_Group_Multisite_Level__c,
            Site_relationships_addition_removal_p__c: summaryReportData.Site_relationships_addition_removal_p__c,
        },

        FscAafData: {
            FSC_AAF_Data__c: summaryReportData.FSC_AAF_Data__c,
            FSC_Data_Recent_FY__c: summaryReportData.FSC_Data_Recent_FY__c,
            FY_Start_Date__c: summaryReportData.FY_Start_Date__c,
            FY_End_Date__c: summaryReportData.FY_End_Date__c,
            FPT_Local_Currency_Unit__c: summaryReportData.FPT_Local_Currency_Unit__c,
            FPT_Turnover_Local_Currency__c: summaryReportData.FPT_Turnover_Local_Currency__c,
            Total_Revenue_Local_Currency__c: summaryReportData.Total_Revenue_Local_Currency__c,
            FPT_Turnover_USD__c: summaryReportData.FPT_Turnover_USD__c,
            Total_Revenue_USD__c: summaryReportData.Total_Revenue_USD__c,

            FPT_TR__c: summaryReportData.FPT_TR__c,

        },

        SummaryOfAssessment: {
            Auditor_Certification_Review_FSC__c: summaryReportData.Auditor_Certification_Review_FSC__c,
            Auditor_Comments_FSC__c: summaryReportData.Auditor_Comments_FSC__c,
            Auditor_Certification_Review_PEFC__c: summaryReportData.Auditor_Certification_Review_PEFC__c,
            Auditor_Comments_PEFC__c: summaryReportData.Auditor_Comments_PEFC__c,
            Auditor_Certification_Review_SFI__c: summaryReportData.Auditor_Certification_Review_SFI__c,
            Auditor_Comments_SFI__c: summaryReportData.Auditor_Comments_SFI__c,
            Auditor_Certification_Review_Other__c: summaryReportData.Auditor_Certification_Review_Other__c,
            Auditor_Comments_Other__c: summaryReportData.Auditor_Comments_Other__c,
            SCS_Certification_Decision_FSC__c: summaryReportData.SCS_Certification_Decision_FSC__c,
            SCS_Decision_Comments_FSC__c: summaryReportData.SCS_Decision_Comments_FSC__c,
            SCS_Certification_Decision_PEFC__c: summaryReportData.SCS_Certification_Decision_PEFC__c,
            SCS_Decision_Comments_PEFC__c: summaryReportData.SCS_Decision_Comments_PEFC__c,
            SCS_Certification_Decision_SFI__c: summaryReportData.SCS_Certification_Decision_SFI__c,
            SCS_Decision_Comments_SFI__c: summaryReportData.SCS_Decision_Comments_SFI__c,
            SCS_Certification_Decision_Other__c: summaryReportData.SCS_Certification_Decision_Other__c,
            SCS_Decision_Comments_Other__c: summaryReportData.SCS_Decision_Comments_Other__c,
            Date_Of_Report_Finalization__c: summaryReportData.Date_Of_Report_Finalization__c,
            Allowable_Size_Limit__c: summaryReportData.Allowable_Size_Limit__c,
            Annual_growth_rate__c: summaryReportData.Annual_growth_rate__c,
            Certificate_Type__c: summaryReportData.Certificate_Type__c,
            Certification_Decision_s_By__c: summaryReportData.Certification_Decision_s_By__c,
        }

    };
    return formateddata;
}


export {
    decodeJWT,
    formatSummaryReportData,
}